import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import * as WorkingPartServices from "../../../../services/WorkingPartService";
import * as CodeService from "../../../../services/CodeService";
import * as TaskService from "../../../../services/TaskService";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import WorkingPartAdminForm from "./workingPartAdminForm.view";
import PATHS from "../../../../constants/paths";
import {
  BreadCrumb,
  ShowAlertDialog,
} from "@de-prado-dev/react-component-library";
import { getIsMangerSelector } from "../../../../store/selectors/authSelector";
import * as UserServices from "../../../../services/UserServices";
import { filter } from "../../../../store/actions/UserActions";

const WorkingPartAdminFormContainer = ({
  isTechnical,
  uuid,
  onCancel,
  onSuccess,
  dailyUuid,
}) => {
  const isManager = useSelector(getIsMangerSelector);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [initValues, setInitValues] = useState({});
  const [codes, setCodes] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [rows, setRows] = useState(0);

  const setInitialValues = useCallback(async (data, codes) => {
    const dataFinal = {
      codeUuid: data.codeUuid,
      initTime: data.initTime,
      endTime: data.endTime,
      numPlants: data.numPlants,
      rows: data.rows,
      taskUuid: data.taskUuid,
      comments: data.comments,
    };
    const dataCode = codes.find((cod) => cod.uuid === data.codeUuid);
    const rowsData = [];
    if (dataCode && dataCode.sector) {
      for (let index = 0; index < dataCode.sector.rows; index++) {
        rowsData.push({ value: index + 1, label: `Fila ${index + 1}` });
      }
    }
    setRows(rowsData);
    setInitValues(dataFinal);
  }, []);

  const loadData = useCallback(async () => {
    const resultCode = await CodeService.listAllCodes();
    if (resultCode) {
      setCodes(resultCode);
    }
    // await TaskService.listAllTask().then((result) => {
    //   setTasks(result);
    // });
    if (uuid) {
      const result = await WorkingPartServices.getWorkingPart(uuid);
      if (result) {
        await setInitialValues(result, resultCode);
      }
    }
  }, [setInitialValues, uuid]);

  useEffect(() => {
    loadData();
  }, []);

  const handleSubmit = async (values) => {
    try {
      if (values) {
        let result = undefined;

        // if (uuid) {
        //   result = await WorkingPartServices.updateWorkingPart(values, uuid);
        // } else {
        result = await WorkingPartServices.adminAddWorkingPart(values);
        // }

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          if (uuid) {
            title = t("forms.workingPart.messages.update.title");
            text = t("forms.workingPart.messages.update.success");
            icon = "success";
          } else {
            title = t("forms.workingPart.messages.create.title");
            text = t("forms.workingPart.messages.create.success");
            icon = "success";
          }
        } else {
          title = "Error";
          text = t("forms.workingPart.messages.update.error");
          icon = "error";
        }

        let okAction = () => {
          onSuccess();
        };
        ShowAlertDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      //console.log('Error', error);
    }
  };

  const handlerOnChangeCode = async (value) => {
    const rowsData = [];
    const dataCode = codes.find((cod) => cod.uuid === value);
    const filters = { culture: dataCode.culture };
    await TaskService.listAllTask({ filters }).then((result) => {
      if (dataCode && dataCode.sector) {
        for (let index = 0; index < dataCode.sector.rows; index++) {
          rowsData.push({ value: index + 1, label: `Fila ${index + 1}` });
        }
      }

      setRows(rowsData);
      setTasks(result);
    });
  };

  const handlerFilterUser = async (value) => {
    const filter = {
      filters: {
        name: value,
      },
    };

    const result = await UserServices.filterAllUser(filter);
    return result;
  };

  return (
    <WorkingPartAdminForm
      isManager={isManager}
      codes={codes}
      tasks={tasks}
      rows={rows}
      edit={uuid ? true : false}
      initialValues={initValues}
      onSubmit={handleSubmit}
      onBack={onCancel}
      onChangeCode={handlerOnChangeCode}
      onFilterUser={handlerFilterUser}
    />
  );
};

WorkingPartAdminFormContainer.propTypes = {
  t: PropTypes.any,
};

export default WorkingPartAdminFormContainer;
